export default {
  strict: true,
  namespaced: true,
  state: {
    driverInfo: {},
    rsvpParams: {},
    rating: {
      value: 0,
      message: ''
    },
    modal: false,
    searchForm: false
  },
  mutations: {
    setDriverInfo (state, value) {
      state.driverInfo = value
    },
    setRsvpParams (state, value) {
      state.rsvpParams = value
    },
    setRating (state, value) {
      state.rating = value
    },
    showModal (state, value) {
      state.modal = value
    },
    setSearchForm (state, value) {
      state.searchForm = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/driver-review/index.js